var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text)?_c('p',{staticClass:"hub-content-message"},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }